import { createStore } from 'vuex'

export default createStore({
  state: {
    baseUrls: "https://www.sxcsgh.com",
    // baseUrls: "http://csgh.tykhrs.site",
    searchNames:"",
    ispc: true,
    routes:[
      {name:"关于我们",paths:"/abouts",keys:"abouts",chirchens:[
        {name:"公司简介",paths:"companyProfile"},
        {name:"发展历程",paths:"developmentHistory"},
        {name:"企业文化",paths:"corporateCulture"},
        {name:"荣誉资质",paths:"honor"},
      ]},
      {name:"服务领域",paths:"/services",keys:"services"},
      {name:"项目展示",paths:"/projecse",keys:"projecse",chirchens:[]},
      {name:"新闻中心",paths:"/news",keys:"news",chirchens:[]},
      {name:"加入我们",paths:"/contens",keys:"contens",chirchens:[
        {name:"联系我们",paths:"talents"},
        {name:"企业加盟",paths:"franchise"},
      ]},
    ],
    banners:[]
  },

  getters: {
  },
  mutations: {
    setbaseUrls(state, urls) {
      state.baseUrls = urls;
    },
    setispc(state, booles) {
      state.ispc = booles;
    },
    setsearchNames(state, texts) {
      state.searchNames = texts;
    },
    setbannersLists(state, lists) {
      state.banners = lists;
    },
    setprojecttype(state, arrs){
      var lists=[{
          name: "全部",
          id: 'all',
          hidens:true
      }]
      arrs.forEach(items=>{
        lists.push({
          name: items.type_name,
          id: items.id,
        })
      })
      state.routes[2].chirchens=lists
    },
    setnewcenterindex(state, arrs){
      var lists=[]
      arrs.forEach(items=>{
        lists.push({
          name: items.type_name,
          id: items.id,
        })
      })
      state.routes[3].chirchens=lists
    },
  },
  actions: {
  },
  modules: {
  }
})
